module.exports = require('../lib/locale/th_TH');